(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/pages/result.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/pages/result.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo;
const ErrorDialog = svs.grassroots.components.ErrorDialog;
const Loader = svs.components.ReactLoader.Loader;
const _svs$grassroots$compo = svs.grassroots.components.result,
  ResultProvince = _svs$grassroots$compo.ResultProvince,
  ResultCountry = _svs$grassroots$compo.ResultCountry,
  ResultSport = _svs$grassroots$compo.ResultSport;
const SearchResults = svs.grassroots.pages.SearchResults;
const _ReactRouterDOM = ReactRouterDOM,
  useParams = _ReactRouterDOM.useParams,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$ui$ReactForm = svs.ui.ReactForm,
  RadioGroup = _svs$ui$ReactForm.RadioGroup,
  RadioButton = _svs$ui$ReactForm.RadioButton,
  Select = _svs$ui$ReactForm.Select,
  Option = _svs$ui$ReactForm.Option,
  Form = _svs$ui$ReactForm.Form,
  ControlGroup = _svs$ui$ReactForm.ControlGroup;
const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const Result = () => {
  const _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    cms = _useState2[0],
    setCms = _useState2[1];
  const _useState3 = useState('sverige'),
    _useState4 = _slicedToArray(_useState3, 2),
    view = _useState4[0],
    setView = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    provinces = _useState6[0],
    setProvinces = _useState6[1];
  const _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    viewDetail = _useState8[0],
    setViewDetail = _useState8[1];
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    sports = _useState0[0],
    setSports = _useState0[1];
  const views = useMemo(() => ['sverige', 'lan', 'forening', 'idrott'], []);
  const _useParams = useParams(),
    paramYear = _useParams.year,
    paramView = _useParams.view,
    paramViewDetail = _useParams.viewDetail;
  const history = useHistory();
  const response = grassrootsQueryApi.useFetchResultProvinceAndSportsQuery();
  const cmsYearlyContent = svs.grassroots_shared_2.data.config.result.sort((a, b) => b.year - a.year);
  const decodeUrlId = p => p.toLowerCase().replace(/\s/g, '-').replace(/[åä]/g, 'a').replace(/ö/g, 'o');

  useEffect(() => {
    setCms(cmsYearlyContent.find(c => c.year.toString() === paramYear && c.publish));
  }, [cmsYearlyContent, paramYear]);

  useEffect(() => {
    if (paramView) {
      setView(views.find(v => v === paramView));
    }
  }, [paramView, views]);

  useEffect(() => {
    if (response.isSuccess && response.data) {
      const newProvinces = response.data.provinces.map(p => ({
        name: p,
        id: decodeUrlId(p)
      }));
      const newSports = response.data.sports.map(s => ({
        name: s,
        id: decodeUrlId(s)
      }));
      setProvinces(newProvinces);
      setSports(newSports);

      if (paramView === 'lan') {
        if (paramViewDetail) {
          const match = newProvinces.find(p => paramViewDetail === p.id);
          if (match) {
            setViewDetail(match);
          }
        } else {
          setViewDetail(newProvinces[0]);
        }
      }

      if (paramView === 'idrott') {
        if (paramViewDetail) {
          const match = newSports.find(p => paramViewDetail === p.id);
          if (match) {
            setViewDetail(match);
          }
        } else {
          setViewDetail(newSports[0]);
        }
      }
    }
  }, [paramView, paramViewDetail, response.data, response.isSuccess]);
  const onChangeHandler = e => {
    history.push("/sagickdet/".concat(paramYear, "/").concat(e));
    setView(e);
  };
  const onViewDetailChangeHandler = e => {
    const id = decodeUrlId(e.target.value);
    setViewDetail({
      name: e.target.value,
      id
    });
    history.push("/sagickdet/".concat(paramYear, "/").concat(paramView, "/").concat(id));
  };
  const onYearChangeHandler = e => {
    if (e.target.value.toString() !== paramYear) {
      if (view === 'lan') {
        if (viewDetail) {
          history.push("/sagickdet/".concat(e.target.value, "/").concat(view, "/").concat(viewDetail.id));
        }
      } else {
        history.push("/sagickdet/".concat(e.target.value, "/").concat(view));
      }
    }
  };

  if (response.isLoading) {
    return React.createElement(Loader, {
      size: 300
    });
  }
  if (cms && view) {
    return React.createElement("div", {
      className: "".concat(svs.grassroots.background, " f-content padding-1")
    }, React.createElement("div", {
      className: "grassroots-result-container"
    }, React.createElement(RadioGroup, {
      branding: svs.grassroots.tenant,
      className: "margin-bottom-1",
      size: 200
    }, React.createElement(RadioButton, {
      checked: view === 'sverige',
      onChange: onChangeHandler,
      value: "sverige"
    }, "SVERIGE"), React.createElement(RadioButton, {
      checked: view === 'lan',
      onChange: onChangeHandler,
      value: "lan"
    }, "L\xC4N"), React.createElement(RadioButton, {
      checked: view === 'forening',
      onChange: onChangeHandler,
      value: "forening"
    }, "F\xD6RENING"), React.createElement(RadioButton, {
      checked: view === 'idrott',
      onChange: onChangeHandler,
      value: "idrott"
    }, "IDROTT")), React.createElement(Form, null, React.createElement(ControlGroup, {
      isLessSpace: true,
      v2: true
    }, (view === 'sverige' || view === 'lan') && React.createElement(Select, {
      id: "sa-gick-det-ar",
      label: "S\xE5 h\xE4r gick det \xE5r ".concat(paramYear),
      onChange: onYearChangeHandler,
      v2: true,
      value: paramYear
    }, cmsYearlyContent.map(result => React.createElement(Option, {
      id: result.year,
      key: result.year,
      name: result.year,
      value: result.year.toString()
    }, result.year))), view === 'sverige' && React.createElement(ResultCountry, {
      cms: cms
    }), view === 'lan' && provinces.length > 0 && React.createElement(ResultProvince, {
      cms: cms,
      currentProvince: viewDetail,
      provinces: provinces,
      setCurrentProvince: onViewDetailChangeHandler
    }), view === 'forening' && React.createElement("div", {
      className: "margin-top-3"
    }, React.createElement(SearchResults, {
      resultPage: true
    })), view === 'idrott' && provinces.length > 0 && React.createElement(ResultSport, {
      cms: cms,
      currentSport: viewDetail,
      setCurrentSport: onViewDetailChangeHandler,
      sports: sports
    })))));
  }
  return React.createElement(ErrorDialog, null);
};
svs.grassroots.pages.Result = Result;

 })(window);